import { createSlice } from "@reduxjs/toolkit";
import { subDays } from "date-fns";

const defaultStartDate = new Date(subDays(new Date(), 30))
  .toISOString()
  .split("T")[0];
const defaultEndDate = new Date(new Date()).toISOString().split("T")[0];

const initialState = {
  currentPage: 1,
  currentFilter: "all",
  currentPageSize: 10,
  sortBy: "",
  sortOrder: "",
  showFilter: false,
  certificateNumber: "",
  tempCertificateNumber: "",
  search: "",
  clearSelection: false,
  selectedItemType: [],
  tempSelectedItemType: [],
  date: [defaultStartDate, defaultEndDate],
};

const imageCertificationSlice = createSlice({
  name: "imageCertification",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
});

export const { updateConfig } = imageCertificationSlice.actions;

export default imageCertificationSlice.reducer;
